import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPabblyIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14699_166497)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M24.333 12.4976C24.333 19.1065 18.9603 24.464 12.333 24.464C10.2551 24.464 8.30052 23.9375 6.59628 23.0106C2.86477 20.9814 0.333008 17.0345 0.333008 12.4976C0.333008 5.88882 5.70559 0.53125 12.3329 0.53125C18.9603 0.53125 24.333 5.88882 24.333 12.4976Z",
					fill: "#20B276"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.1205 15.9034C15.8506 17.2081 14.3093 17.861 12.4971 17.861C11.3911 17.861 10.3635 17.6744 9.40015 17.1322L9.38856 24.0799L9.29728 24.0554L9.24077 24.041L9.17407 24.0047L9.14263 23.948L9.11368 23.884L9.14578 23.8439L5.96777 20.0663L5.9687 11.1365C5.9687 9.27589 6.60362 7.69563 7.87372 6.3955C9.14355 5.09528 10.6847 4.44531 12.4971 4.44531C14.3093 4.44531 15.8505 5.09759 17.1205 6.40262C18.3904 7.70747 19.0255 9.29105 19.0255 11.1531C19.0255 13.0154 18.3904 14.5986 17.1205 15.9034ZM14.6963 8.89144C14.0934 8.27133 13.3602 7.96142 12.4971 7.96142C11.6337 7.96142 10.9006 8.27133 10.2978 8.89144C9.69479 9.51153 9.39329 10.2653 9.39329 11.1533C9.39329 12.041 9.6947 12.7948 10.2978 13.4148C10.9006 14.0351 11.6337 14.3451 12.4971 14.3451C13.3602 14.3451 14.0934 14.0351 14.6963 13.4148C15.2993 12.7948 15.6008 12.041 15.6008 11.1533C15.6008 10.2653 15.2993 9.51143 14.6963 8.89144Z",
					fill: "#147F52"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.8702 15.6567C15.6001 16.962 14.0588 17.6149 12.2465 17.6149C11.1404 17.6149 10.1059 17.3437 9.14258 16.8014L9.14156 24.0414C9.14156 24.0414 8.90712 23.9771 8.60198 23.8788C8.52674 23.8546 8.45076 23.8286 8.37116 23.8006C8.3333 23.7871 8.31484 23.7793 8.27587 23.7681C8.17605 23.7395 8.0495 23.6841 7.95199 23.6463C7.62431 23.519 7.35878 23.3978 7.35238 23.3948C7.34598 23.3917 6.40802 22.9456 6.30226 22.8797C6.20753 22.8207 6.1232 22.7745 6.05093 22.7227C6.02783 22.7063 6.01039 22.6945 5.98849 22.6795C5.81667 22.5617 5.72065 22.4941 5.72065 22.4941L5.71777 10.8886C5.71777 9.02726 6.35272 7.44653 7.62291 6.14609C8.89292 4.84539 10.4341 4.19531 12.2466 4.19531C14.0589 4.19531 15.6001 4.84779 16.8703 6.15322C18.1402 7.45845 18.7755 9.04253 18.7755 10.9051C18.7753 12.7676 18.1401 14.3515 16.8702 15.6567ZM14.4458 8.64261C13.8428 8.02231 13.1098 7.7123 12.2464 7.7123C11.3829 7.7123 10.6498 8.02231 10.047 8.64261C9.44391 9.26289 9.14249 10.0168 9.14249 10.9051C9.14249 11.7932 9.44391 12.5472 10.047 13.1673C10.6498 13.7879 11.3829 14.098 12.2464 14.098C13.1096 14.098 13.8428 13.7879 14.4458 13.1673C15.0487 12.5472 15.3504 11.7932 15.3504 10.9051C15.3504 10.0168 15.0487 9.26289 14.4458 8.64261Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_14699_166497",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 23.9404,
				fill: "white",
				transform: "translate(0.333008 0.529297)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPabblyIcon);
export { ForwardRef as ReactComponent };
